import axios from 'axios';

const api = axios.create({
     // baseURL: 'http://localhost:5100'
     baseURL: 'https://aspenimmigration.ca/api/'
});

export const sendMail = (data) => api.post('/contact', data);
export const sendRequest = (data) => api.post('/request', data);